import {
  GET_ALL_STAFF_LIST_REQUEST,
  GET_ALL_STAFF_LIST_SUCCESS,
  GET_ALL_STAFF_LIST_FAILURE,
  GET_USER_ACCESS_LIST_REQUEST,
  GET_USER_ACCESS_LIST_SUCCESS,
  GET_USER_ACCESS_LIST_FAILURE,
  UPDATE_USER_ACCESS_REQUEST,
  UPDATE_USER_ACCESS_SUCCESS,
  UPDATE_USER_ACCESS_FAILURE,
  GET_DEFAULT_ACCESS_REQUEST,
  GET_DEFAULT_ACCESS_SUCCESS,
  GET_DEFAULT_ACCESS_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  staffList: {},
  userAccess: {},
  updateAccess:{},
  defaultAccess:{},
  loading: false,
  error: null,
};

export const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_STAFF_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_STAFF_LIST_SUCCESS:
      return {
        ...state,
        staffList: action.payload,
        loading: false,
        error: null,
      };

    case GET_ALL_STAFF_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // User Access Get & Update

    case GET_USER_ACCESS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_USER_ACCESS_LIST_SUCCESS:
      return {
        ...state,
        userAccess: action.payload,
        loading: false,
        error: null,
      };
    case GET_USER_ACCESS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "CLEAR_USER_ACCESS":
      return {
        ...state,
        userAccess: null,
        error: null,
        loading: false,
      };

    case UPDATE_USER_ACCESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_USER_ACCESS_SUCCESS:
      return {
        ...state,
        updateAccess: action.payload,
        loading: false,
        error: null,
      };
    case UPDATE_USER_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_DEFAULT_ACCESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_DEFAULT_ACCESS_SUCCESS:
      return {
        ...state,
        defaultAccess: action.payload,
        loading: false,
        error: null,
      };
    case GET_DEFAULT_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
